import React from "react";
import { Layout, Input, Row, Typography, Col, Card, Collapse } from "antd";
import appLabel from "../config/appLabel";

const { Text } = Typography;

export default function RecordStatus(props) {
  const { authStatus, makerID, makerDate, checkerID, checkerDate } = props;

  return (
    <></>
    // <Card
    //   title={
    //     <div
    //       style={{
    //         backgroundColor: "#1bb394",
    //         width: 120,
    //         borderRadius: "10px",
    //         marginLeft: "auto",
    //       }}
    //     >
    //       <Text
    //         style={{
    //           marginLeft: "10%",
    //           color: "white",
    //         }}
    //       >
    //        {appLabel.recordStatus}
    //       </Text>
    //     </div>
    //   }
    //   style={{
    //     boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
    //     borderRadius: 20,
    //     marginTop: "20px"
    //   }}
    // >
    //   <Row style={{ justifyContent: "space-between" }}>
    //     <Col style={{ width: "20vh" }}>
    //       <Text strong>{appLabel.authStatus}</Text>
    //       <Input
    //         defaultValue={authStatus}
    //         disabled
    //         style={{ width: "100%" }}
    //       />
    //     </Col>
    //     <Col style={{ width: "30vh" }}>
    //       <Text strong>{appLabel.makerId}</Text>
    //       <Input defaultValue={makerID} disabled style={{ width: "100%" }} />
    //     </Col>
    //     <Col style={{ width: "15vh" }}>
    //       <Text strong>{appLabel.makerDate}</Text>
    //       <Input
    //         defaultValue={makerDate}
    //         disabled
    //         style={{ width: "100%" }}
    //       />
    //     </Col>
    //     <Col style={{ width: "30vh" }}>
    //       <Text strong>{appLabel.checkerId}</Text>
    //       <Input
    //         defaultValue={checkerID}
    //         disabled
    //         style={{ width: "100%" }}
    //       />
    //     </Col>
    //     <Col style={{ width: "15vh" }}>
    //       <Text strong>{appLabel.checkerDate}</Text>
    //       <Input
    //         defaultValue={checkerDate}
    //         disabled
    //         style={{ width: "100%" }}
    //       />
    //     </Col>
    //   </Row>
    // </Card>
  );
}
